<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title data-cy="create-or-update-external-link-dialog-title">
    {{ externalLinkForm.id.value ? 'Modifier' : 'Ajouter' }} un lien
  </span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    <div class="external-link-form">
      <tiime-input-container
        contentId="name"
        label="Titre"
        [required]="true"
        [errorMessage]="externalLinkForm.nameErrorMessage?.message"
      >
        <input
          #nameInput
          id="name"
          autocomplete="off"
          type="text"
          placeholder="Titre"
          [formControl]="externalLinkForm.name"
        />
      </tiime-input-container>
      <tiime-input-container
        contentId="url"
        label="Url"
        [required]="true"
        [errorMessage]="externalLinkForm.urlErrorMessage?.message"
      >
        <input id="url" autocomplete="off" type="text" placeholder="Url" [formControl]="externalLinkForm.url" />
      </tiime-input-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      tiime-button
      color="accent"
      strocked
      large
      [disabled]="externalLinkForm.disabled"
      (click)="cancel()"
      data-cy="create-or-update-external-link-dialog-cancel-btn"
    >
      Annuler
    </button>
    <button
      tiime-button
      color="accent"
      large
      raised
      [disabled]="externalLinkForm.disabled"
      (click)="submitExternalLinkForm()"
      data-cy="create-or-update-external-link-dialog-save-btn"
    >
      {{ externalLinkForm?.id.value ? 'Modifier' : 'Ajouter' }}
    </button>
  </mat-dialog-actions>
</tiime-dialog>
